<template>
  <div class="issued-passes-list-page">
    <vue-headful title="Реестр выданных пропусков" />

    <div class="container">
      <div class="content">
        <alert v-if="xlsStatus" dismissible :type="alertType" @dismissed="xlsStatus = ''">{{ xlsStatus }}</alert>
        <div class="row">
          <div class="col-md-8">
            <h2>Реестр выданных пропусков</h2>
          </div>
        </div>

        <hr>

        <div class="row">
          <div class="col-md-12 input-group">
            <date-picker
              v-model="dateRange"
              :disabled-date="disabledDates"
              :range="true"
              format="DD.MM.YYYY"
              value-type="YYYY-MM-DD"
              placeholder="Период выдачи"
              @change="handleSearch()"
            />
            <div class="input-group-btn">
              <button type="button" class="btn btn-default" @click="onClickExport">
                <span>
                  <img :src="baseUrl + '/vue/img/excel_icon.png'" alt='export-excel' style="height: 17px">
                </span>
              </button>
            </div>
          </div>
        </div>

        <table v-if="issuedPasses && issuedPasses.length" class="table">
          <thead>
            <tr>
              <th colspan="2">ФИО</th>
              <th colspan="2">Организация-заявитель</th>
              <th>Номер пропуска</th>
              <th>Выдан</th>
              <th>Кем выдан</th>
              <th>Оператор</th>
              <th>Дата начала действия</th>
              <th>Дата окончания действия</th>
              <th>Номер заявки</th>
              <th>ОТИ</th>
            </tr>
          </thead>
          <tbody v-for="issuedPass in issuedPasses" :key="issuedPass.id">
            <tr>
              <td colspan="2">
                <router-link :to="`visitor/list?search=${issuedPass.full_name}&filterColumns=full_name`">
                  {{ issuedPass.full_name }}
                </router-link>
              </td>
              <td colspan="2">{{ issuedPass.organization_name }}</td>
              <td style="text-align: center">
                <a
                  style="cursor: pointer"
                  @click="givePdfPass(issuedPass.application_id, issuedPass.personal_id, issuedPass.transport_id)"
                >
                  {{ issuedPass.pass_number }}
                </a>
              </td>
              <td style="text-align: center">{{ issuedPass.issue_date }}</td>
              <td style="text-align: center">{{ issuedPass.guardian }}</td>
              <td style="text-align: center">{{ issuedPass.operator }}</td>
              <td style="text-align: center">{{ issuedPass.period_of }}</td>
              <td style="text-align: center">{{ issuedPass.period_to }}</td>
              <td style="text-align: center">
                <router-link :to="getApplicationListLinkByNumber(issuedPass.application_number, issuedPass.period_to)">
                  {{ issuedPass.application_number }}
                </router-link>
              </td>
              <td style="text-align: center">{{ issuedPass.terminal_name }}</td>
            </tr>
          </tbody>
        </table>

        <infinite-loading :identifier="infiniteId" @infinite="infiniteLoadIssuedPasses">
          <div slot="no-more">Показаны все записи</div>
          <div slot="no-results">Нет записей</div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
import '@/common/assets/styles/issued-passes-list-styles.scss'
import mainMixin from '@/common/mixins/mainMixin'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import axios from 'axios'
import moment from 'moment/moment'
import PermissionsMixin from '@/common/mixins/PermissionsMixin'
import PermissionsEnum from '@/common/enums/PermissionsEnum'
import ActionListMenuMixin from '@/common/mixins/actionListMenuMixin'

export default {
  name: 'IssuedPassesList',

  mixins: [mainMixin, PermissionsMixin, ActionListMenuMixin],

  data() {
    return {
      alertType: '',
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      dateRange: [],
      exportModel: 'issuedPasses',
      infiniteId: 0,
      issuedPasses: [],
      searchChanged: false,
      pagination: {
        active: 1,
        per: 10
      },
      preloader: true,
      xlsStatus: ''
    }
  },

  async created() {
    if (!this.hasPermission(PermissionsEnum.canUseIssuedPassesPage)) {
      this.needLoadPage = false
      window.location.href = ApiClient.getApplicationScreenUrl()
    }

    const vue = this
    this.pagination.active = history.state?.page ?? 1

    this.hidePreloader()
    window.addEventListener('popstate', (event) => {
      if (event.state) {
        vue.fillSearchParamsFromState(event)
        vue.clearSearch(this.pagination.active)
      }
    })
  },

  methods: {
    async clearSearch(page) {
      this.pagination.active = page
      this.issuedPasses = []
      this.infiniteId += 1
    },

    disabledDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    fillSearchParamsFromState({ dateRange, page }) {
      this.dateRange = dateRange ?? null
      this.pagination.active = page ?? 1
    },

    getApplicationListLinkByNumber(applicationNumber, periodTo) {
      const [day, month, year] = periodTo.split('.')
      const now = new Date()
      const archived = new Date(year, month - 1, day) < now.setHours(0, 0, 0, 0) ? '1' : '0'

      return `application/list?archived=${archived}&search=${applicationNumber}` +
        '&filter=all&typeFilter=all&subdivFilter=all&filterColumns=number&page=1'
    },

    async getPageIssuedPasses(activePage, perPage = null) {
      let results = []

      await ApiClient.getIssuedPassesList({
        page: activePage,
        perPage: perPage || this.pagination.per,
        dateOf: this.dateRange[0],
        dateTo: this.dateRange[1]
      }).then((response) => {
        results = response?.data?.data?.models
      })

      return results
    },

    async givePdfPass(applicationId, personalId, transportId) {
      const pdfPassBlobResponse = await ApiClient.getPass(
        applicationId,
        personalId,
        transportId ?? null,
        false,
        false
      )
      this.openPdfInNewTab(pdfPassBlobResponse.data)
    },

    async infiniteLoadIssuedPasses($state) {
      let issuedPasses
      if (!this.issuedPasses.length) {
        this.pagination.active = 1
        if (Object.keys(this.$route.query).length) {
          this.fillSearchParamsFromState({
            dateRange: this.dateRange ?? this.$route.query.dateRange
          })
        }
      }

      issuedPasses = await this.getPageIssuedPasses(this.pagination.active)

      if (issuedPasses?.length) {
        this.pagination.active++
        this.issuedPasses.push(...issuedPasses)
        $state.loaded()
      } else if (issuedPasses?.length === 0) {
        $state.complete()
      } else {
        $state.error()
      }

      this.replaceStatePageData()
    },

    handleSearch() {
      if (this.searchChanged) {
        return
      }
      this.searchChanged = true
      this.clearSearch('1')

      setTimeout(() => {
        this.searchChanged = false
      }, 500)
    },

    replaceStatePageData() {
      const params = history.state ?? this.dateRange
      params.page = this.pagination.active

      const url = new URL(window.location)
      url.searchParams.set('page', this.pagination.active)
      history.replaceState(params, undefined, url.href)
    },

    onClickExport() {
      const vue = this;
      let query = ''
      if (this.dateRange.length === 2) {
        query = '?dateOf=' + this.dateRange[0] + '&dateTo=' + this.dateRange[1]
      }

      vue.xlsStatus = 'Экспорт данных начался.'
      vue.alertType = 'info'
      axios({
        method: 'get',
        url: this.baseUrl + '/export/issued' + query,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          Accept: 'application/json, text/javascript, */*; q=0.01'
        },
        responseType: 'blob'
      }).then(function (result) {
        if (Number(result.status) !== 400) {
          const url = window.URL.createObjectURL(new Blob([result.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'export_' + moment().format('DD.MM.YYYY_hh:mm:ss') + '.xlsx')
          link.click()
          link.remove()
          vue.xlsStatus = 'Данные успешно экспортированы'
          vue.alertType = 'success'
        } else {
          vue.xlsStatus = result.message ? result.message : 'Не удалось экспортировать данные.'
          vue.alertType = 'danger'
        }
      })
        .catch(function () {
          vue.xlsStatus = 'Не удалось экспортировать данные.'
          vue.alertType = 'danger'
        });
    }
  }
}
</script>
